<template>
  <common-dialog ref="dialog" :title="title" width="1000px" :in-dialog="inDialog" @opened="onOpened"
    @closed="isShow = false">
    <div class="select_box" v-if="isShow">
      <div class="select_table">
        <el-input v-model="searchContent" :placeholder="'搜索' + keyName" @keyup.enter.native="getTableData" clearable
          style="width: 180px;margin-right: 10px;" />
        <el-button type="primary" @click="getTableData">搜索</el-button>
        <el-table :data="showData" border max-height="530" style="width: 100%;margin-top: 10px;">
          <el-table-column :prop="keyValue" :label="keyName" align="center" />
          <el-table-column :prop="secondValue" :label="secondName" v-if="secondValue" width="160" align="center" />
          <el-table-column prop="name" label="操作" width="65" align="center">
            <template slot-scope="{row,$index}">
              <el-button type="text" v-if="row.checked" style="color: #ccc;">已选择</el-button>
              <el-button type="text" v-else @click="selectRow(row, $index)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="select_table">
        <span style="vertical-align: -webkit-baseline-middle;">已选</span>
        <el-button type="primary" @click="clear" :disabled="checkedData.length == 0"
          style="float: right;">清空</el-button>
        <el-table :data="checkedData" border max-height="530" style="width: 100%;margin-top: 14px;">
          <el-table-column :prop="keyValue" :label="keyName" align="center" />
          <el-table-column :prop="secondValue" :label="secondName" v-if="secondValue" width="160" align="center" />
          <el-table-column prop="name" label="操作" width="65" align="center">
            <template slot-scope="{row,$index}">
              <el-button type="text" @click="deleteRow(row, $index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <template slot="footer">
      <slot name="footer">
        <el-button type="primary" @click="selectMultiple">选择</el-button>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import listDialogMixins from "@/mixins/listDialog";

export default {
  components: { commonDialog },
  mixins: [listDialogMixins],
  data() {
    return {
      isShow: false,
      searchContent: "",
      tableData: [],
      showData: [],
      checkedData: [],
    };
  },
  props: {
    title: {
      type: String,
      default: "选择",
    },
    func: {
      type: Function,
      default: undefined,
    },
    keyId: {
      type: String,
      default: "Id",
    },
    keyValue: {
      type: String,
      default: "No",
    },
    keyName: {
      type: String,
      default: "",
    },
    defaultValue: {
      type: Array,
      default: null,
    },
    secondValue: {
      type: String,
      default: "",
    },
    secondName: {
      type: String,
      default: "",
    },
    params: {
      type: Object,
      defalut: () => {},
    },
  },
  methods: {
    onOpened() {
      this.isShow = true;
      this.searchContent = "";
      this.tableData = [];
      this.showData = [];
      this.checkedData = [].concat(this.defaultValue);
    },
    getTableData() {
      this.func({ [this.keyValue]: this.searchContent, ...this.params }).then(res => {
        if (res.Code == 0) {
          this.tableData = res.Data;
          // let arr = this.defaultValue.split(",");
          // let arr2 = [];
          // arr.forEach(e => {
          //   let obj = this.tableData.find(x => x[this.keyValue] == e);
          //   if(obj) arr2.push(obj);
          // })
          // if(arr2.length) this.checkedData = arr2;
          if (this.checkedData.length) {
            this.tableData.forEach(e => {
              let index = this.checkedData.findIndex(x => e[this.keyId] == x[this.keyId]);
              if (index > -1) e.checked = true;
            })
          }
          this.showData = this.tableData;
        }
      })
    },
    // search(e = "") {
    //   this.showData = [];
    //   this.$nextTick(() => {
    //     let arr = this.tableData.filter(x => x[this.keyValue].indexOf(e) > -1);
    //     arr.forEach(e => {
    //       let has = this.checkedData.find(x => x[this.keyId] == e[this.keyId]);
    //       e.checked = Boolean(has);
    //     })
    //     this.showData = arr;
    //   })
    // },
    selectRow(e, index) {
      let obj = { ...e, checked: true };
      this.showData.splice(index, 1, obj);
      this.checkedData.push(obj);
    },
    deleteRow(e, index) {
      let index2 = this.showData.findIndex(x => x[this.keyId] == e[this.keyId]);
      if (index2 > -1) {
        e.checked = false;
        this.showData.splice(index2, 1);
        this.$nextTick(() => this.showData.splice(index2, 0, e));
      }
      this.checkedData.splice(index, 1);
    },
    clear() {
      this.showData = [];
      this.checkedData = [];
      this.tableData.forEach(e => {
        e.checked = false;
      })
      this.$nextTick(() => {
        this.showData = this.tableData;
      })
    },
    selectMultiple() {
      let arr = this.checkedData.map(x => { return x[this.keyValue] }).join(",");
      let arr2 = this.checkedData.map(x => { return x[this.keyId] });
      this.$emit('select-multiple', this.checkedData,arr,arr2);
      this.close();
    },
  },
};
</script>
<style lang="scss" scoped>
.select_box {
  display: flex;
  justify-content: space-between;

  .select_table {
    width: 49%;
  }
}
</style>